import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WaiterService } from '../../_service/waiter.service';
import { Location } from '@angular/common';
import { CartComponent } from '../../common/cart/cart.component';
import { debounceTime, distinctUntilChanged, of, Subject, switchMap } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';


@Component({
  selector: 'app-categories',
  standalone: true,
  imports: [RouterModule, CommonModule, NgbModule, CartComponent, FormsModule],
  templateUrl: './categories.component.html',
  styleUrl: './categories.component.scss',
  animations: [
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(30px)' }),
        animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ]),
    trigger('staggerAnimation', [
      transition('* => *', [
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(30px)' }),
          stagger(100, [
            animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
          ])
        ], { optional: true })
      ])
    ]),
    trigger('slideDown', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
      ])
    ])
  ]
})
export class AddItemsCategoriesComponent implements OnInit {
  colorClasses = ['bg-light-red', 'bg-light-green', 'bg-light-yellow', 'bg-light-brown'];
  private modalService = inject(NgbModal);
  categories: any[] = [];
  tableValue: string | null = null;
  id: string | null;
  orderDetails: any;
  searchTerm: string = '';
  searchResults: any[] = [];
  isLoading: boolean = false;
  isCategoriesLoading: boolean = true;
  isOrderDetailsLoading: boolean = true;
  showDropdown: boolean = false;
  private searchSubject = new Subject<string>();

  // Skeleton loader helper
  skeletonItems = Array(8).fill(0); // For 8 skeleton category items
  constructor(
    private app: WaiterService, private route: ActivatedRoute, private router: Router, private location: Location) {
    this.id = route.snapshot.paramMap.get('id')
    // Initialize search observer
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(term => {
        const storedArray = localStorage.getItem('orders') ? JSON.parse(localStorage.getItem('orders')!) : null;

        if (!term.trim()) {
          this.showDropdown = false;
          return of([]);
        }
        this.isLoading = true;
        return this.app.searchInventory(term, storedArray.barcode_id);
      })
    ).subscribe({
      next: (results) => {
        this.searchResults = results;
        this.isLoading = false;
        this.showDropdown = true;
        if (this.searchTerm == '') {
          this.showDropdown = false;
        }
      },
      error: (error) => {
        console.error('Search error:', error);
        this.isLoading = false;
      }
    });
  }
  ngOnInit(): void {
    this.fetchAllCategories()
    this.getOrderDetails()
  }
  cart(content: any) {
    // this.loadCartItems()
    this.modalService.open(content, { centered: true }).result
  }
  getRandomColorClass(index: number): string {
    return this.colorClasses[index % this.colorClasses.length]; // Cycles through color classes
  }
  getOrderDetails() {
    this.isOrderDetailsLoading = true;
    this.app.viewOrder(this.id).subscribe({
      next: (res) => {
        this.orderDetails = res;
        this.isOrderDetailsLoading = false;
      },
      error: (err) => {
        console.error('Error fetching order details:', err);
        this.isOrderDetailsLoading = false;
      }
    })
  }

  goBack() {
    this.location.back();  // Navigate back to the previous route
  }

  fetchAllCategories() {
    this.isCategoriesLoading = true;
    this.app.fetchAllCategories().subscribe({
      next: (res: any) => {
        this.categories = res;
        this.isCategoriesLoading = false;
      },
      error: (err: any) => {
        console.log(err);
        this.isCategoriesLoading = false;
        // this.alertService.danger(err.error.message)
        // Swal.fire('', err.error.message, 'error')
      },
      complete: () => {
        // this.listEvents()
        // this.getEventById()
        // this.router.navigateByUrl('/events/' + this.id + '/rsvp')
      }
    })
  }

  // Track by function for better performance
  trackByCategory(index: number, category: any): any {
    return category.id || index;
  }

  // Image error handler
  onImageError(event: any): void {
    event.target.src = 'icons/placeholder-category.svg'; // Fallback image
  }
  selectItem(item: any): void {
    this.searchTerm = item.name;
    this.showDropdown = false;
    if (item && item.category_id) {
      this.router.navigate(['/create-order/categories/', item.category_id]);
    }
    this.searchTerm = '';
    this.showDropdown = false;
    this.searchResults = [];
    // Additional logic for selection...
  }

  // c// Add to your component class
  closeDropdown(): void {
    this.showDropdown = false;
    this.searchResults = [];
  }

  // Update onSearch method
  onSearch(event: any): void {
    const term = event.target.value;
    this.searchTerm = term;

    if (term.trim()) {
      this.showDropdown = true;
      this.searchSubject.next(term);
    } else {
      this.showDropdown = false;
      this.searchResults = [];
    }
  }

  ngOnDestroy() {
    this.searchSubject.complete();
  }
}
